
import * as React from 'react';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { Strings } from '../../../../utils/resources/strings';
import { GridTabViewModelImpl } from '../../../toolkit/gridtabs/gridtabviewmodel';
import { GridTabComponent } from '../../../toolkit/gridtabs/gridtabcomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import './flash-message-style.css';
import { FlashMessageComponentProps, FlashMessageComponentState } from './flashmessagecomponent';
import { FlashMessageCSSStyle } from './flashmessagecss';
import { FlashMessageTabViewModelImpl } from './flashmessagetabviewmodel';
import { FlashMessageListViewModelImpl } from './flashmessagelistviewmodel';
import { FlashMessageDto, FlashMessageDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { FlashMessageSubscriptionDetailsComponent } from './flashmessagesubscriptiondetails/flashmessagesubscriptiondetailscomponent';
import { SetFlashMessageComponent } from '../../popup/flashmessage/setflashmessage/setflashmessagecomponent';
import { CreateFlashMessageComponent } from '../../popup/flashmessage/createflashmessage/createflashmessagecomponent';
import { SubscriptionFlashMessageComponent } from '../../popup/flashmessage/flashsubscription/flashsubscriptioncomponent';
import { FlashMessageOTPVerificationComponent } from '../../popup/flashmessage/flashotp/flashmessageotpverificationcomponent';
import { FlashMessageDefaultListViewModelImpl } from './flashmessagedefaultlistviewmodel';
import { FlashMessageDefaultTabViewModelImpl } from './flashmessagedefaulttabviewmodel';

export class FlashMessageViewImpl extends CRBTUIViewImpl {
    private genericTabViewModel: GridTabViewModelImpl;
    private gridTabRef: GridTabComponent;
    private defaultgenericTabViewModel: GridTabViewModelImpl;
    private defaultgridTabRef: GridTabComponent;
    private popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent: LoaderWrapperComponent;
    private featuredCategoryTonesListMap = new Map<string, FlashMessageDto[]>();
    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(context, uiComponentHandler);

        this.featuredCategoryTonesListMap = new Map<string, FlashMessageDto[]>();
        this.genericTabViewModel = new GridTabViewModelImpl();
        this.defaultgenericTabViewModel = new GridTabViewModelImpl();

    }

    bindHandlers() {
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onTabSelected = this.onTabSelected.bind(this);
        this.showMore = this.showMore.bind(this);
        this.showLess = this.showLess.bind(this);
        this.showSubscriptionDetails = this.showSubscriptionDetails.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showOTPPopUp = this.showOTPPopUp.bind(this);
        this.onCreateClicked = this.onCreateClicked.bind(this);
        this.onEditClicked = this.onEditClicked.bind(this);
        this.onSetNow = this.onSetNow.bind(this);
        this.showPopup = this.showPopup.bind(this);
    }

    getChildComponent(props: FlashMessageComponentProps, state: FlashMessageComponentState, cssStyle: FlashMessageCSSStyle): JSX.Element {
        return (
            <>
                <div id="flash-message-div">
                    <label id="flash-message-header-title" style={cssStyle.getHeaderCssStyle()}>
                        {props.context.getResources().getString(Strings.flash_message)}
                    </label>
                    <label id="flash-message-header-subtitle" style={cssStyle.getSubHeaderCssStyle()}>
                        {
                            props.context.getResources().getString(Strings.flash_message_content)}
                    </label>
                    {
                        props.context.getUserContext().getIsLoggedIn() &&
                        <FlashMessageSubscriptionDetailsComponent context={props.context} />
                    }
                    <div id="flash-messages-wrapper-div-default">
                        <GridTabComponent isShowTabsTitle={false} id="flash-messages-grid-tabs-default" onTabSelected={this.onTabSelected} ref={(item: any) => { this.defaultgridTabRef = item; }} initialTab={this.getContext().getResources().getString(Strings.default_flash_message)} genericTabViewModel={this.defaultgenericTabViewModel} context={props.context} />
                    </div>
                    <div id="flash-messages-wrapper-div">
                        <GridTabComponent isShowTabsTitle={false} id="flash-messages-grid-tabs" onTabSelected={this.onTabSelected} ref={(item: any) => { this.gridTabRef = item; }} initialTab={this.getContext().getResources().getString(Strings.predefined_flash_message)} genericTabViewModel={this.genericTabViewModel} context={props.context} />
                    </div>


                    <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context} />

                    <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context} />
                </div>
            </>
        );
    }

    closePopup() {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id: string, msg: string, type: AlertType): void {
        this.closePopup();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context} />);
    }
    showLoader() {

        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true, <LoaderComponent context={this.getUIProps().context} />);
    }

    dismissLoader() {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getNavigationPath() {
        return [this.getUIProps().context.getResources().getString(Strings.home),
        this.getUIProps().context.getResources().getString(Strings.flash_message)];
    }

    getBannerImg() {
        return "flashmessage.jpg";
    }

    removeAllTabs() {
        this.genericTabViewModel.removeAllTabs();
    }

    setDefaultFlashMessage(title: string, dto: FlashMessageDto) {
        this.defaultgenericTabViewModel.addTab(new FlashMessageDefaultTabViewModelImpl(this.getContext(),
            new FlashMessageDefaultListViewModelImpl("10",
                this.getContext(), title, this.onCreateClicked),
            title));

        let tab = this.defaultgenericTabViewModel.getTab(title);

        tab !== undefined && (tab as FlashMessageTabViewModelImpl).updateTabData([dto],
            true, 0, false);

        this.updateTab(this.defaultgenericTabViewModel.getListOfTitles()[0]);
        this.defaultgridTabRef.onTabSelected(this.defaultgenericTabViewModel.getSelectedTabTitle());
    }


    setFlashMessageMap(featuredCategoryMap: Map<string, string>) {
        featuredCategoryMap.forEach((value: string, title: string) => {
            this.featuredCategoryTonesListMap.set(title, []);
            this.genericTabViewModel.addTab(new FlashMessageTabViewModelImpl(this.getContext(),
                new FlashMessageListViewModelImpl("10",
                    this.getContext(), title, this.onSetNow),
                title, this.showMore, this.showLess));

            let tab = this.genericTabViewModel.getTab(title);

            tab !== undefined && (tab as FlashMessageTabViewModelImpl).updateTabData([],
                true, 0, false);
        });

        this.updateTab(this.genericTabViewModel.getListOfTitles()[0]);
    }

    updateTabData(context: BaseContext, title: string, tonedto: FlashMessageDto[]) {
        this.featuredCategoryTonesListMap.set(title, tonedto);

        let tab = this.genericTabViewModel.getTab(title);

        (tab !== undefined) && (tab as FlashMessageTabViewModelImpl).updateTabData(tonedto.slice(0, 5), true, 0, false);
        this.gridTabRef.onTabSelected(this.genericTabViewModel.getSelectedTabTitle());
        let showmore = document.getElementById("flash-messages-grid-tabs");
        if (showmore !== null) {
            let offsetTop = showmore.getBoundingClientRect().top + window.scrollY;
            console.log("------offsetTop: " + offsetTop);
            window.scroll(0, (offsetTop - 200));
        }
    }

    showMore() {
        console.log("showMore");
        let tab = this.genericTabViewModel.getTab(this.genericTabViewModel.getSelectedTabTitle());
        let toneDtoList = this.featuredCategoryTonesListMap.get(this.genericTabViewModel.getSelectedTabTitle());

        if (tab !== undefined && toneDtoList !== undefined) {
            this.featuredCategoryTonesListMap.set(this.genericTabViewModel.getSelectedTabTitle(), toneDtoList);

            (tab as FlashMessageTabViewModelImpl).updateTabData(toneDtoList, false, 0, true);
            this.gridTabRef.onTabSelected(this.genericTabViewModel.getSelectedTabTitle());

            let showmore = document.getElementById("flash-messages-grid-tabs");
            if (showmore !== null) {
                let offsetTop = showmore.getBoundingClientRect().top + window.scrollY;
                console.log("------offsetTop: " + offsetTop);
                window.scroll(0, (offsetTop - 200));
            }
        }
    }

    showLess() {
        console.log("showless");
        let tab = this.genericTabViewModel.getTab(this.genericTabViewModel.getSelectedTabTitle());
        let toneDto = this.featuredCategoryTonesListMap.get(this.genericTabViewModel.getSelectedTabTitle());

        if (tab !== undefined && toneDto !== undefined) {
            let filteredToneDtos: FlashMessageDto[] = [];

            toneDto.forEach((toneDto1: FlashMessageDto, index: number) => {
                (index <= 3) && filteredToneDtos.push(toneDto1);
            });

            (tab as FlashMessageTabViewModelImpl).updateTabData(filteredToneDtos, true, 0, true);
            this.gridTabRef.onTabSelected(this.genericTabViewModel.getSelectedTabTitle());
        }
    }
    updateTab(title: string) {
        this.gridTabRef.onTabSelected(title);
    }
    getListOfTitles(): string[] {
        return this.genericTabViewModel.getListOfTitles();
    }

    onTabSelected() {

    }

    onCreateClicked() {
        let flashDto = new FlashMessageDtoImpl();
        flashDto.setId("0");
        flashDto.setPlanName("");
        flashDto.setStatusMessage("");
        flashDto.setMsisdn(this.getUIProps().context.getUserContext().getMsisdn());

        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <CreateFlashMessageComponent isMessageEditable={false} headerTitle={this.getUIProps().context.getResources().getString(Strings.create_flash_message)} showSetFlash={this.onSetNow} showSubscriptionDetails={this.showSubscriptionDetails} showPopup={this.showPopup} closePopup={this.closePopup} flashMessageDto={flashDto} context={this.getUIProps().context} />);
    }

    onEditClicked(flashMessageDto: FlashMessageDto) {
        let flashDto = new FlashMessageDtoImpl();
        flashDto.setId(flashMessageDto.getId());
        flashDto.setPlanName(flashMessageDto.getPlanName());
        flashDto.setStatusMessage(flashMessageDto.getStatusMessage());
        flashDto.setMsisdn(this.getUIProps().context.getUserContext().getMsisdn());

        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <CreateFlashMessageComponent isMessageEditable={true} headerTitle={this.getUIProps().context.getResources().getString(Strings.edit_flash_message)} showSetFlash={this.onSetNow} showSubscriptionDetails={this.showSubscriptionDetails} showPopup={this.showPopup} closePopup={this.closePopup} flashMessageDto={flashDto} context={this.getUIProps().context} />);
    }

    onSetNow(flashDto: FlashMessageDto) {
        this.closePopup();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <SetFlashMessageComponent showSubscriptionDetails={this.showSubscriptionDetails} showPopup={this.showPopup} closePopup={this.closePopup} flashMessageDto={flashDto} context={this.getUIProps().context} />);
    }

    showSubscriptionDetails(flashMessageDto: FlashMessageDto): void {
        this.closePopup();
        console.log("this.state.isAllCallersSelected: " + flashMessageDto.getIsAllCallers());
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <SubscriptionFlashMessageComponent showOTPPopUp={this.showOTPPopUp} showPopup={this.showPopup} closePopup={this.closePopup} flashMessageDto={flashMessageDto} context={this.getUIProps().context} />);
    }

    showOTPPopUp(flashMessageDto: FlashMessageDto): void {
        this.closePopup();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <FlashMessageOTPVerificationComponent showPopup={this.showPopup} closePopup={this.closePopup} flashMessageDto={flashMessageDto} context={this.getUIProps().context} />);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessageview.tsx